export default __webpack_public_path__ + "static/media/Visa_logo.1fae40ca.svg";